import React, { useEffect, useState } from 'react';
import ReactApexChart from "react-apexcharts";

const AudienceEngagementChart = (props) => {

    const [chartData, setChartData] = useState(null);
    const [visibleSeries, setVisibleSeries] = useState({
        registration: true,
        footfall: true
    });
    useEffect(() => {
        if (props.chartData) {
            // Generate temporary Footfall data (registration +/- 1000)
            const registrationData = props.chartData.seriesData || [];
            // const footfallData = registrationData.map((value) => {
            //     if (!value || value === 0) {
            //         // Generate random number between 0 and 2000 for zero values
            //         return Math.floor(Math.random() * 2001);
            //     }
            //     // Generate random variation between -1000 and +1000
            //     const variation = Math.floor(Math.random() * 2001) - 1000;
            //     return Math.max(0, value + variation); // Ensure non-negative
            // });
            const footfallData = props.chartData.footfallSeriesData || [];

            const data = {
                series: [
                    {
                        name: 'Registration',
                        data: registrationData,
                        //radius: 12,	
                    },
                    {
                        name: 'Footfall',
                        data: footfallData,
                    },
                ],
                options: {
                    chart: {
                        type: 'line',
                        height: 380,
                        toolbar: {
                            show: false,
                        },
                    },
                    colors: ['#0E8A74', '#BE282D'],
                    dataLabels: {
                        enabled: false,
                    },
                    legend: {
                        show: false,
                    },
                    stroke: {
                        show: true,
                        width: 6,
                        curve: 'smooth',
                        colors: ['#0E8A74', '#BE282D'],
                    },
                    grid: {
                        show: true,
                        borderColor: '#C8C8C8',
                        strokeDashArray: 4,
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0

                        }
                    },

                    xaxis: {
                        categories: props.chartData.categories,
                        axisBorder: {
                            show: true,
                        },
                        axisTicks: {
                            show: true
                        },
                        labels: {
                            show: true,
                            style: {
                                fontSize: '14px',
                                colors: '#a4a7ab',
                            }
                        },
                        crosshairs: {
                            show: false,
                            position: 'front',
                            stroke: {
                                width: 1,
                                dashArray: 3
                            }
                        },
                        tooltip: {
                            enabled: true,
                            formatter: undefined,
                            offsetY: 0,
                            style: {
                                fontSize: '12px',
                            }
                        }
                    },
                    yaxis: {
                        show: true,
                        labels: {
                            offsetX: -10,
                            formatter: function (value) {
                                return value > 1000 ? (value / 1000) + 'k' : value;
                            },
                            style: {
                                fontSize: '14px',
                                colors: '#a4a7ab',
                            }
                        }
                    },
                    fill: {
                        opacity: 1,
                        colors: '#FB3E7A'
                    },
                    tooltip: {
                        shared: true,
                        intersect: false,
                        style: {
                            fontSize: '12px',
                        },
                        y: {
                            // formatter: function (val, opts) {
                            //     const seriesNames = ['Registration', 'Footfall'];
                            //     const seriesIndex = opts.seriesIndex;
                            //     const formattedValue = val > 1000 ? (val / 1000).toFixed(2) + 'k' : val;
                            //     return formattedValue;
                            // }
                            formatter: function (val) {
                                // Format with commas: 17676 -> 17,676
                                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            }
                        }
                    },

                    responsive: [{
                        breakpoint: 575,
                        options: {
                            chart: {
                                height: 250,
                            },
                        },
                    }]
                },
            };
            setChartData(data);
        }
    }, [props.chartData]);
    const toggleSeries = (seriesName) => {
        if (seriesName === 'registration') {
            setVisibleSeries(prev => ({ ...prev, registration: !prev.registration }));
        } else if (seriesName === 'footfall') {
            setVisibleSeries(prev => ({ ...prev, footfall: !prev.footfall }));
        }
    };

    const getFilteredSeries = () => {
        if (!chartData) return [];
        const filtered = [];
        const filteredColors = [];

        chartData.series.forEach((series, index) => {
            if (index === 0 && visibleSeries.registration) {
                filtered.push(series);
                filteredColors.push('#0E8A74');
            } else if (index === 1 && visibleSeries.footfall) {
                filtered.push(series);
                filteredColors.push('#BE282D');
            }
        });

        return { series: filtered, colors: filteredColors };
    };

    return (
        <div className="card event-bx">
            <div className="card-header border-0 mb-0">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <h4 className="card-title font-w500 mb-0">Audience Engagement</h4>
                    <div className="d-flex gap-3 align-items-center ms-auto">
                        <div className="form-check form-check-inline d-flex align-items-center">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="toggleRegistration"
                                checked={visibleSeries.registration}
                                onChange={() => toggleSeries('registration')}
                                style={{ cursor: 'pointer', marginRight: '4px', marginTop: 0 }}
                            />
                            <label className="form-check-label mb-0" htmlFor="toggleRegistration" style={{ cursor: 'pointer', fontSize: '16px' }}>
                                <span style={{ color: '#0E8A74', fontWeight: 500 }}>Registration</span>
                            </label>
                        </div>
                        <div className="form-check form-check-inline d-flex align-items-center">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="toggleFootfall"
                                checked={visibleSeries.footfall}
                                onChange={() => toggleSeries('footfall')}
                                style={{ cursor: 'pointer', marginRight: '4px', marginTop: 0 }}
                            />
                            <label className="form-check-label mb-0" htmlFor="toggleFootfall" style={{ cursor: 'pointer', fontSize: '14px' }}>
                                <span style={{ color: '#BE282D', fontWeight: 500 }}>Footfall</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="dz-scroll">
                <div className="card-body pt-0">
                    <div id="chart">
                        {!chartData ? null : (() => {
                            const filtered = getFilteredSeries();
                            const updatedOptions = {
                                ...chartData.options,
                                colors: filtered.colors,
                                stroke: {
                                    ...chartData.options.stroke,
                                    colors: filtered.colors
                                }
                            };
                            return (
                                <ReactApexChart
                                    options={updatedOptions}
                                    series={filtered.series}
                                    type="line"
                                    height="380px"
                                />
                            );
                        })()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AudienceEngagementChart;